import type { ComponentProps } from "react";
import { ProviderType } from "@wags/catalog/pure.ts";
import {
    PROVIDER_CLAIM_VISIBLE,
    ProviderClaimEntryCard,
    providerClaimUrl,
} from "@/features/providers";

export function ClaimEntry({
    providerId,
    providerName,
    providerType,
    listingId,
    surface,
    className,
    enabled,
    isVerified,
}: {
    providerId: string | null | undefined;
    providerName: string | null | undefined;
    providerType: ProviderType;
    listingId?: string;
    surface?: ComponentProps<typeof ProviderClaimEntryCard>["surface"];
    className?: string;
    enabled: boolean;
    isVerified: boolean;
}) {
    if (!PROVIDER_CLAIM_VISIBLE || !enabled || !providerId || isVerified)
        return null;
    return (
        <ProviderClaimEntryCard
            subject={listingId ? "listing" : "page"}
            providerName={providerName?.trim() || undefined}
            providerKind={
                providerType === ProviderType.Breeder ? "breeder" : "shelter"
            }
            surface={surface}
            className={className}
            href={providerClaimUrl(providerId)}
        />
    );
}
